module.exports = __webpack_public_path__ + "img/Superb_sword_18.8061b2cf.png";